import React, { FC } from 'react';

import { startCase } from 'lodash';
import * as Types from 'types';
import { getResolutionLabelByWidth } from '../../helpers';
import { formatDuration } from 'services/stringFormating';

type Props = {
  type: Types.ArtworkType;
  remainingEditions: number;
  publishedAt?: Date;
  resolution?: {
    width: number;
    height: number;
  };
  duration?: number;
};

export const ArtworkExtraInfo: FC<Props> = ({
  type,
  remainingEditions,
  publishedAt,
  resolution,
  duration,
}) => (
  <div className='d-flex flex-wrap flex-sm-column flex-md-row mb-1'>
    {!!publishedAt && (
      <div className='mr-1 pr-mini'>
        Published &nbsp;
        {publishedAt.getFullYear()}
      </div>
    )}
    {!!type && (
      <div className='mr-1 pr-mini'>
        {getResolutionLabelByWidth(resolution?.width)}
        &nbsp;
        {startCase(type)}
      </div>
    )}
    {!!duration && (
      <div className='mr-1 pr-mini'>
        Duration &nbsp;
        {formatDuration(duration)}
      </div>
    )}
    {!!remainingEditions && (
      <div className='mr-1 pr-mini'>
        Remaining editions &nbsp;
        {remainingEditions}
      </div>
    )}
  </div>
);
